import React from 'react';
import styles from './preloader.css';

/**
 *
 * @type {React.NamedExoticComponent<object>}
 */
const Preloader = React.memo( () => {
    return (
        <div className={ styles.preloader }>
            <div className={ styles.loader }/>
        </div>
    );
} );

export default Preloader;